import { render, staticRenderFns } from "./LdGatedRouterLink.vue?vue&type=template&id=6d552956"
import script from "./LdGatedRouterLink.vue?vue&type=script&lang=js"
export * from "./LdGatedRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports